import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export const dateRangeValidator = (startKey: string, endKey: string): ValidatorFn => {
  return (group: AbstractControl): ValidationErrors | null => {
    const start = group.get(startKey)?.value as Date | undefined;
    const end = group.get(endKey)?.value as Date | undefined;

    // let required validators handle missing values
    if (!start || !end) return null;

    // compare timestamps
    return new Date(end).getTime() < new Date(start).getTime() ? { dateRangeInvalid: true } : null;
  };
};